module.exports = __webpack_public_path__ + "img/own_ideas.4492f3a7.svg";